import { Switch } from 'sonata-react-components';

import { AssignDealsModal } from '../AssignDealsModal';
import { DealsManager } from '../DealsManager/DealsManager';
import { useMenu } from '../Menu.context';
import { MyPixels } from '../MyPixels';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function MenuActions({ user, userRoles }: Props) {
  const {
    setMenuItemSelected,
    state: { mainItemSelected }
  } = useMenu();

  const handleModalClose = (): void => {
    setMenuItemSelected(null);
  };

  return (
    <Switch>
      <Switch.Case condition={mainItemSelected === 'dealManagerModal'}>
        <DealsManager onClose={handleModalClose} user={user} userRoles={userRoles} />
      </Switch.Case>
      <Switch.Case condition={mainItemSelected === 'pixels'}>
        <MyPixels onClose={handleModalClose} user={user} userRoles={userRoles} />
      </Switch.Case>
      <Switch.Case condition={mainItemSelected === 'assignDealsModal'}>
        <AssignDealsModal isOpen onClose={handleModalClose} user={user} userRoles={userRoles} />
      </Switch.Case>
    </Switch>
  );
}

export default MenuActions;
